import { z } from 'zod';

import { isoDateTimeSchema, uuidSchema } from './common.js';

export const shopLeaveMarkerKindSchema = z.enum(['dayOff', 'changedSchedule']);
export type ShopLeaveMarkerKind = z.infer<typeof shopLeaveMarkerKindSchema>;

export const shopLeaveMarkerSchema = z.object({
  requestId: uuidSchema,
  employeeId: uuidSchema,
  employeeName: z.string(),
  /** YYYY-MM-DD */
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  kind: shopLeaveMarkerKindSchema,
});
export type ShopLeaveMarkerDto = z.infer<typeof shopLeaveMarkerSchema>;

export const bookingMarkerSchema = z.object({
  bookingId: uuidSchema,
  hostUserId: uuidSchema,
  inviteeName: z.string(),
  inviteeEmail: z.string().email(),
  inviteeNote: z.string().nullable(),
  startAt: isoDateTimeSchema,
  endAt: isoDateTimeSchema,
  /** YYYY-MM-DD in host (Moscow) timezone for calendar grouping */
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
});
export type BookingMarkerDto = z.infer<typeof bookingMarkerSchema>;
